'use client';

import { captureReferrer } from '@/utils/referrer';
import { useEffect } from 'react';

export function ReferrerCapture() {
  useEffect(() => {
    captureReferrer();
  }, []);

  return null;
}
